import React from 'react'
import './styles/Intro.css'

function Intro({ toggle }) {

  const scrollToExperience = () => {
    const experience = document.getElementById('experience')
    experience.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center'
    })
  }

  return (
    <div id="about" className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4 py-20">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Profile Image Section */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <img
                src="/porfile-picture.jpg"
                alt="Fahd Saleh"
                className="pfp-image w-80 h-80 rounded-full object-cover shadow-2xl border-4 border-white"
              />
              <div className="absolute -bottom-4 -right-4 bg-blue-600 text-white p-4 rounded-full shadow-lg">
                <i className="bi bi-code-slash text-2xl"></i>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="text-center lg:text-left space-y-6">
            <div className="space-y-2">
              <p className="text-blue-600 font-semibold text-lg tracking-wide">Hello, I'm</p>
              <h1 className="name text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Fahd Saleh
              </h1>
              <h2 className="text-2xl lg:text-3xl font-semibold text-gray-700">
                Software Engineer
              </h2>
            </div>

            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
              Passionate software engineer with experience in full-stack development and
              microservices architecture. I love building 
              scalable solutions and turning complex problems into elegant code.
            </p>

            <div className="flex flex-wrap gap-4 justify-center">
              <button onClick={scrollToExperience} className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg">
                View My Work
              </button>
            </div>

            <div className="flex gap-6 justify-center pt-4">
              <a href="https://www.linkedin.com/in/fahd-saleh/" target='_blank' rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600 transition-colors duration-300">
                <i className="bi bi-linkedin text-2xl"></i>
              </a>
              <a href="https://github.com/fahd209" target='_blank' rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600 transition-colors duration-300">
                <i className="bi bi-github text-2xl"></i>
              </a>
              <span onClick={toggle} className="text-gray-600 hover:text-blue-600 transition-colors duration-300 cursor-pointer">
                <i className="bi bi-envelope text-2xl"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Intro